<a
  [href]="link"
  [target]="target">
  <ppl-icon
    [svgIcon]="icon"
    height="32px"
    width="32px"></ppl-icon>
  <div class="name">{{ name }}</div>
</a>
